import { motion, Variants } from "framer-motion";
import styled from "styled-components";
import { easings } from "../../styles/utils";
import { Text } from "../Text";
import { navItems } from "../../data/nav";
import { NavItem } from "./NavItem";

const Wrapper = styled(motion.nav)`
  min-height: 200px;
  /* min-width: 400px; */
`;

const NavList = styled.ul``;

const NavListItem = styled(motion.li)`
  position: relative;
  display: block;
  font-weight: 700;
  margin: 32px 0;
  cursor: pointer;
  transform-origin: left;
`;

const navVariants: Variants = {
  initial: {
    y: -40,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.2, ease: easings.easeOutCubic },
  },
  exit: {
    y: 40,
    opacity: 0,
    transition: { duration: 0.3, ease: easings.easeOutCubic },
  },
};

export const Nav: React.FC = () => {
  return (
    <Wrapper
      initial="initial"
      animate="animate"
      exit="exit"
      variants={navVariants}
    >
      <NavList>
        {navItems.map((navItem) => (
          <NavListItem
            key={navItem.path}
            whileHover={{ scale: 1.02 }}
            // onMouseLeave={() => handleMouseLeave()}
          >
            <NavItem to={navItem.path}>
              <Text as="span" fontSize="inherit">
                {navItem.title}
              </Text>
            </NavItem>
          </NavListItem>
        ))}
      </NavList>
    </Wrapper>
  );
};
